angular.module('cvsApp').service('patientMessagePreference', ['networkService', 'xdrService', 'configManager', 'patientMessagePreferenceResponseModel', 'cvsAppData', function(NS, XS, CM, PSM, CAD) {

    function patientMessagePreference() {
        this.patientMessagePreference = function(callBackSuccess, rxNumber,dob,dispensingHbsSiteId,dispensingCatsBranchId,phoneNumber, channels,messageEvents) {
                var tokenId= CAD.getTokenId();
                var tokenType= CAD.getTokenType();
                var apikey = CAD.getApiKey();
                var url = CM.getApiUrlWOQueryParams('PATIENT_MSG_PREF', "", CAD.getTokenType());
                //console.log("url", url)
            if (url === "URL_ERROR") {

            } else {
                var request = {
                    url: url,
                    header: {
                            Accept: 'application/json'
                    },
                    data: requestBody(rxNumber,dob,dispensingHbsSiteId,dispensingCatsBranchId,phoneNumber,channels, messageEvents),
                    onSuccess: callBackSuccess
                }

                    cvsUtility.commonServiceCode(url,"patientMessagePreference",PSM,request,callBackSuccess,NS);
            }

        }

        var requestBody = function(rxNumber,dob,dispensingHbsSiteId,dispensingCatsBranchId,phoneNumber,channels,messageEvents) {
            var tokenType = CAD.getTokenType();
            var apikey = CAD.getApiKey();
            var reqObj = {
                "selfEnrollRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
                            "tokenType": tokenType
                        },
                        "securityContext": {
                            "apiKey": apikey
                        }
                    },
                    "details": {
                        "rxNumber": rxNumber,
                        "dob": dob,
                        "dispensingHbsSiteId" : dispensingHbsSiteId,
                        "dispensingCatsBranchId" : dispensingCatsBranchId,
                        "phoneNumber" : phoneNumber,
                        "channels": channels,
                        "messageEvents": messageEvents
                    }
                }
            };
            if(phoneNumber === ""){
                delete reqObj.phoneNumber;
            }
            return reqObj;

        }

    }

    return new patientMessagePreference();
}]);